/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Badge, Card, Modal, Row, CardBody, CardHeader, Container, Form } from 'reactstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile"
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import SweetAlert from "react-bootstrap-sweetalert";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../Style.css"

const PettyCashPage = () => {
    const warehouse = localStorage.warehouse;
    const token = localStorage.token;
    const username = localStorage.username;
    const [rowIndex, setRowIndex] = useState(0);
    const [AllPettyCash, setAllPettyCash] = useState([]);
    const [nameAsset, setNameAsset] = useState("");
    const [codeAsset, setCodeAsset] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerpage] = useState(10);
    const [totalItem, setTotalItem] = useState(0);
    const [currentSort, setCurrentSort] = useState("");
    const [modalTutorial, setModalTutorial] = useState(false);

    let paginationOption = {
        page: page,
        alwaysShowAllBtns: true,
        override: true,
        showTotal: true,
        withFirstAndLast: false,
        sizePerPage: perPage,
        totalSize: totalItem,
        onPageChange: (page) => {
            updateDataTable(page, perPage, currentSort, nameAsset, codeAsset, startDate, endDate);
        },
        sizePerPageRenderer: () => (
            <div className="dataTables_length" id="datatable-basic_length">
                <label>
                    Show{" "}
                    {
                        <select
                            name="datatable-basic_length"
                            aria-controls="datatable-basic"
                            className="form-control form-control-sm"
                            onChange={(e) => {
                                updateDataTable(page, e.target.value, currentSort)
                            }}
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                    }{" "}
                    entries.
                </label>
            </div>
        ),
    }

    const updateDataTable = (page, perPage, sort, nameAsset, codeAsset, startDate, endDate) => {
        getPettyCash(page, perPage, sort, nameAsset, codeAsset, startDate, endDate);
        setPage(page);
        setPerpage(perPage);
        setRowIndex((page - 1) * perPage);
        setCurrentSort(sort);
        setNameAsset(nameAsset);
        setCodeAsset(codeAsset);
        setStartDate(startDate);
        setEndDate(endDate);
    }

    const handleTableChange = (type, { sortField, sortOrder }) => {
        if (type === "sort") {
            let sort = `${sortField} ${sortOrder}`
            updateDataTable(page, perPage, sort, nameAsset, codeAsset, startDate, endDate)
        }
    }

    useEffect(() => {
        getPettyCash(page, perPage, currentSort, "", "", "", "", "");
    }, []);

    const getPettyCash = (page) => {
        let filter = {
            page: page,
            per_page: 500,
            warehouse_id: parseInt(warehouse),
            username: username
        }
        const data = filter;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/petty-cash/page`, data, {
            headers
        })
            .then(data => {
                setAllPettyCash(data.data.response);
                setPage(data.data.current_page + 1);
                setPerpage(data.data.per_page);
                setTotalItem(data.data.total_item);
            })
            .catch(function (error) {
                setAllPettyCash(error.response.data.response)
            })
    }

    return (
        <div style={{ overflow: "hidden" }}>
            <SimpleHeaderMobile to="/mobile/staff-absen" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardHeader>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <h2 className="mb-0 d-flex align-items-center">
                                        Histori Pettycash
                                        <i
                                            className="fa fa-question-circle ml-2 text-info"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setModalTutorial(true)}
                                            title="Lihat Tutorial"
                                        />
                                    </h2>

                                </div>
                            </CardHeader>
                            <CardBody>
                                {AllPettyCash === null ? (
                                    <div className="d-lg-block d-none">
                                        <CardHeader>
                                            <center><h3>DATA NOT FOUND</h3></center>
                                        </CardHeader>
                                    </div>
                                ) : (
                                    <div className="d-lg-block d-none">
                                        <ToolkitProvider
                                            rowNumber={rowIndex}
                                            data={AllPettyCash}
                                            keyField="id"
                                            columns={[
                                                {
                                                    dataField: "no",
                                                    text: "#",
                                                    sort: true,
                                                    page: 1,
                                                    formatter: (cell, row, index) => {
                                                        let currentRow = ++index;
                                                        return currentRow + rowIndex;
                                                    }
                                                },
                                                {
                                                    dataField: "ijin_date",
                                                    text: "Tanggal Izin",
                                                    sort: true,
                                                },
                                                {
                                                    dataField: "name",
                                                    text: "Nama",
                                                    sort: true,
                                                },
                                                {
                                                    dataField: "keterangan",
                                                    text: "Keterangan",
                                                    sort: true,
                                                },
                                                {
                                                    dataField: "approve",
                                                    text: "Status",
                                                    sort: true,
                                                    formatter: (cell, row) => {
                                                        return row.approve === 3
                                                            ?
                                                            <Badge color="" className="badge-dot mr-4">
                                                                <i className="bg-danger" />
                                                                Proses
                                                            </Badge>
                                                            : row.approve === 4
                                                                ? <Badge color="" className="badge-dot mr-4">
                                                                    <i className="bg-warning" />
                                                                    Tidak Setuju
                                                                </Badge>
                                                                : <Badge color="" className="badge-dot mr-4">
                                                                    <i className="bg-success" />
                                                                    Setuju
                                                                </Badge>;
                                                    },
                                                },
                                            ]}
                                        >
                                            {(props) => (
                                                <div className="py-4 table-responsive">
                                                    <BootstrapTable
                                                        remote
                                                        {...props.baseProps}
                                                        bootstrap4={true}
                                                        bordered={false}
                                                        hover={true}
                                                        pagination={paginationFactory({ ...paginationOption })}
                                                        onTableChange={handleTableChange}
                                                    />
                                                </div>
                                            )}
                                        </ToolkitProvider>
                                    </div>
                                )}
                                {AllPettyCash === null ? (
                                    <div className="d-lg-none d-xl-none">
                                        <CardHeader>
                                            <center><h3>DATA NOT FOUND</h3></center>
                                        </CardHeader>
                                    </div>
                                ) : (
                                    <Form>
                                        <PerfectScrollbar>
                                            <div
                                                className="d-lg-none d-xl-none"
                                                style={{ top: 100, zIndex: 3, maxHeight: "35rem", paddingTop: "0.5rem" }}
                                            >
                                                {AllPettyCash.map((v) => {
                                                    let badgeColor = "secondary";
                                                    let badgeText = "Baru";
                                                    let dynamicLink = "/mobile/pettycash/detail/" + v.id;
                                                    let onClickAction = () => { }; // default, tidak ngapa-ngapain

                                                    if (v.approve === 3 && v.active_flag === 1) {
                                                        badgeColor = "warning";
                                                        badgeText = "Proses";
                                                        dynamicLink = "/mobile/pettycash/edit/" + v.id;
                                                    } else if (v.approve === 4 && v.active_flag === 2) {
                                                        badgeColor = "danger";
                                                        badgeText = "Ditolak";
                                                        dynamicLink = "/mobile/pettycash/detail/" + v.id;
                                                    } else if (v.approve === 5 && v.active_flag === 2) {
                                                        badgeColor = "success";
                                                        badgeText = "Selesai";
                                                        dynamicLink = "/mobile/pettycash/detail/" + v.id;
                                                    } else if (v.active_flag === 3) {
                                                        badgeColor = "danger";
                                                        badgeText = "Upload Data";
                                                        dynamicLink = "/mobile/pettycash/item/" + v.id;
                                                        onClickAction = () => {
                                                            localStorage.setItem("cp", v.petty_cash_code);
                                                        };
                                                    } else if (v.active_flag === 4) {
                                                        badgeColor = "success";
                                                        badgeText = "Checking";
                                                        dynamicLink = "/mobile/pettycash/detail/" + v.id;
                                                    }

                                                    return (
                                                        // 
                                                        <Link to={dynamicLink} key={v.id} onClick={onClickAction}>
                                                            <Card className="bg-gradient-info mb-3 shadow border-0">
                                                                <CardBody className="p-3">
                                                                    <Row>
                                                                        <div className="col">
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <h5 className="text-white mb-1">{v.created_at}</h5>
                                                                                <Badge color={badgeColor} pill>
                                                                                    {badgeText}
                                                                                </Badge>
                                                                            </div>
                                                                            <div
                                                                                className="text-white font-weight-bold"
                                                                                style={{
                                                                                    overflow: "hidden",
                                                                                    textOverflow: "ellipsis",
                                                                                    display: "-webkit-box",
                                                                                    WebkitLineClamp: 1,
                                                                                    WebkitBoxOrient: "vertical",
                                                                                }}
                                                                            >
                                                                                {v.judul}
                                                                            </div>
                                                                        </div>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Link>
                                                    );
                                                })}
                                            </div>
                                        </PerfectScrollbar>
                                    </Form>
                                )}
                            </CardBody>
                        </Card>
                    </div>
                </Row>
            </Container>
            <Modal isOpen={modalTutorial} toggle={() => setModalTutorial(false)}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-title-default">
                        📘 Tutorial Penggunaan Petty Cash
                    </h5>
                    <button
                        aria-label="Close"
                        className="close"
                        type="button"
                        onClick={() => setModalTutorial(false)}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <p><strong>1. Tambah Petty Cash:</strong> Klik tombol <i className="fa fa-plus" /> untuk membuat petty cash baru.</p>
                    <p><strong>2. Status:</strong></p>
                    <ul>
                        <li><Badge color="warning">Proses</Badge>: Menunggu persetujuan.</li>
                        <li><Badge color="danger">Ditolak</Badge>: Pengajuan ditolak.</li>
                        <li><Badge color="success">Selesai</Badge>: Sudah disetujui dan selesai.</li>
                    </ul>
                    <p><strong>3. Edit Data:</strong> Klik pada item yang berstatus <Badge color="warning">Proses</Badge> untuk mengedit atau unggah dokumen.</p>
                    <p><strong>4. Upload Data:</strong> Klik pada item yang berstatus <Badge color="warning">Upload Data</Badge> untuk unggah dokumen.</p>
                    <p><strong>5. Riwayat:</strong> Semua pengajuan yang pernah dibuat akan tampil di halaman ini sesuai statusnya.</p>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setModalTutorial(false)}>
                        Tutup
                    </button>
                </div>
            </Modal>
            <div className="d-lg-none d-xl-none">
                <Link
                    style={{
                        paddingTop: 20,
                        height: 70,
                        width: 70,
                        borderRadius: "50%",
                    }}
                    className="btn-danger text-center fixed-whatsapp encepnurdin"
                    to="/mobile/pettycash/create"
                >
                    <i className="fa fa-plus fa-2x" aria-hidden="true" />
                </Link>
            </div>
        </div>
    );
}

export default PettyCashPage;